import { clog } from './clog';

export class EventHandlerClass {
  parent;
  functionMap: any;

  constructor(parent: any) {
    this.functionMap = {};
    this.parent = parent;
  }

  addEventListener(event: string, func: any, capture = false) {
    this.functionMap[event] = func;
    const realEvent = event.split('.')[0];
    this.parent.addEventListener(realEvent, this.functionMap[event], capture);
  }

  removeEventListener(event: any, capture = false) {
    const realEvent = event.split('.')[0];
    const func = this.functionMap[event];
    this.parent.removeEventListener(
      realEvent,
      this.functionMap[event],
      capture
    );
    delete this.functionMap[event];
  }
}
